"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_dom_1 = require("react-dom");
exports.default = (function (elementId, getApp) {
    if (elementId.startsWith('data-')) {
        document.querySelectorAll("[".concat(elementId, "]")).forEach(function (el) {
            var element = el;
            (0, react_dom_1.render)(getApp(element), el);
        });
    }
    else {
        var el = document.getElementById(elementId);
        if (el) {
            var element = el;
            (0, react_dom_1.render)(getApp(element), el);
        }
    }
});
